/* Lawazen Next — homepage behaviour. Build 2026-09-06-p2b */
(function () {
  'use strict';
  if (window.__lzNext) return;
  window.__lzNext = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- hero crossfade ---------------- */
  function hero(root) {
    if (root.dataset.lzBound) return; root.dataset.lzBound = '1';
    var every = parseInt(root.dataset.lzInterval, 10) || 4000;
    var btn = root.querySelector('[data-lz-hero-toggle]');
    var search = root.querySelector('.lz-search');
    var timer = null, paused = false, on = false;
    if (root.querySelectorAll('img').length < 2 || reduce) { if (btn) btn.hidden = true; return; }
    function tick() { if (paused) return; on = !on; root.classList.toggle('is-swapped', on); }
    function start() { stop(); timer = setInterval(tick, every); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (btn) btn.addEventListener('click', function () {
      paused = !paused;
      btn.textContent = paused ? '▶' : 'Ⅱ';
      btn.setAttribute('aria-label', btn.dataset[paused ? 'lzResume' : 'lzPause'] || '');
    });
    if (search) {
      search.addEventListener('focusin', function () { paused = true; });
      search.addEventListener('focusout', function () { paused = false; });
    }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  /* ---------------- applications banner ---------------- */
  function banner(root) {
    if (root.dataset.lzBound) return; root.dataset.lzBound = '1';
    var slides = [].slice.call(root.querySelectorAll('.lz-slide'));
    if (slides.length < 2) return;
    var every = parseInt(root.dataset.lzInterval, 10) || 5200;
    var i = 0, timer = null, paused = reduce;
    var prev = root.querySelector('[data-lz-prev]');
    var next = root.querySelector('[data-lz-next]');
    var play = root.querySelector('[data-lz-play]');
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var active = k === i;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
    }
    function start() { stop(); if (!paused) timer = setInterval(function () { show(i + 1); }, every); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    if (play) play.addEventListener('click', function () {
      paused = !paused;
      play.textContent = paused ? '▶' : 'Ⅱ';
      play.setAttribute('aria-label', play.dataset[paused ? 'lzResume' : 'lzPause'] || '');
      start();
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    show(0); start();
  }

  /* ---------------- client marquee ----------------
     The track has to be at least twice the visible width before the -50%
     loop is seamless, and it must not start scrolling until the logos have
     actually decoded, or the first pass shows empty space. */
  function marquee(root) {
    if (root.dataset.lzBound) return; root.dataset.lzBound = '1';
    var run = root.querySelector('.lz-marquee__run');
    if (!run) return;
    var originals = [].slice.call(run.children);
    if (!originals.length) return;

    function widthOf(el) { return el.getBoundingClientRect().width; }

    function fill() {
      var need = (root.getBoundingClientRect().width || 900) * 1.2;
      var guard = 0;
      while (widthOf(run) < need && guard < 8) {
        originals.forEach(function (n) { run.appendChild(n.cloneNode(true)); });
        guard++;
      }
      // one final duplication so translateX(-50%) lands on an identical frame
      var half = [].slice.call(run.children);
      half.forEach(function (n) { run.appendChild(n.cloneNode(true)); });
    }

    function ready() { root.classList.add('is-ready'); }

    fill();
    var imgs = [].slice.call(run.querySelectorAll('img'));
    var pending = imgs.filter(function (im) { return !im.complete; });
    if (!pending.length) { ready(); return; }
    var left = pending.length, done = false;
    function tick() { if (--left <= 0 && !done) { done = true; ready(); } }
    pending.forEach(function (im) {
      im.addEventListener('load', tick, { once: true });
      im.addEventListener('error', tick, { once: true });
    });
    setTimeout(function () { if (!done) { done = true; ready(); } }, 2500);
  }

  /* ---------------- dialogs ---------------- */
  function dialogs(scope) {
    (scope || document).querySelectorAll('[data-lz-open]').forEach(function (btn) {
      if (btn.dataset.lzBound) return; btn.dataset.lzBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var d = document.getElementById(btn.dataset.lzOpen);
        if (!d) return;
        if (typeof d.showModal === 'function') { d.showModal(); } else { d.setAttribute('open', ''); }
      });
    });
    (scope || document).querySelectorAll('[data-lz-close]').forEach(function (btn) {
      if (btn.dataset.lzBound) return; btn.dataset.lzBound = '1';
      btn.addEventListener('click', function () {
        var d = btn.closest('dialog');
        if (!d) return;
        if (typeof d.close === 'function') { d.close(); } else { d.removeAttribute('open'); }
      });
    });
    (scope || document).querySelectorAll('dialog.lz-dialog').forEach(function (d) {
      if (d.dataset.lzBound) return; d.dataset.lzBound = '1';
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-lz-hero]').forEach(hero);
    root.querySelectorAll('[data-lz-banner]').forEach(banner);
    root.querySelectorAll('[data-lz-marquee]').forEach(marquee);
    dialogs(root);
    if (window.lzExploreInit) window.lzExploreInit(root);
  }

  window.lzInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
  console.info('[Lawazen Next] homepage build 2026-09-06-p2b');
})();
